<script type="module">
import "./style.css";

export default {
  name: "App",
  props: ['lang', 'productItem', 'restUrl'],
  data() {
    return {
      message: "hello!",
    };
  }
};
</script>

<template>
  <Calculator
    name=""
    :lang="lang"
    :productItem="productItem"
    :restUrl ="restUrl"
    :token="token"
  />
</template>
